import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import View from '../../components/View/View';
import Navbar from '../../components/View/Navbar/Navbar';
import NavbarLeft from '../../components/View/Navbar/NavbarLeft/NavbarLeft';
import NavbarRight from '../../components/View/Navbar/NavbarRight/NavbarRight';
import NavbarTitle from '../../components/View/Navbar/NavbarTitle/NavbarTitle';
import DrawerToggler from '../../components/View/SideDrawer/DrawerToggler/DrawerToggler';
import Page from '../../components/View/Page/Page';
import PageContent from '../../components/View/PageContent/PageContent';

import styles from './Gear.module.css';

const GEAR_ITEMS = [
  {
    id: 'belt',
    name: 'Lifting Belt',
    vendor: 'Dominion Strength Training',
    description: 'Heavy-duty leather belt built for squats and deadlifts.',
    url: 'https://www.dominionstrengthtraining.com/',
    cta: 'Shop Belts',
  },
  {
    id: 'shoes',
    name: 'Lifting Shoes',
    vendor: 'Amazon',
    description: 'Flat, hard-soled shoes for a stable base under the bar.',
    // TODO: swap to SS Gyms Amazon affiliate link once Nick sets one up.
    url: 'https://www.amazon.com/s?k=weightlifting+shoes',
    cta: 'Shop Shoes',
  },
];

class Gear extends Component {
  state = { showSideDrawer: false };

  sideDrawerClosedHandler = () => this.setState({ showSideDrawer: false });
  sideDrawerTogglerHandler = () =>
    this.setState(prev => ({ showSideDrawer: !prev.showSideDrawer }));

  render() {
    return (
      <View
        showSideDrawer={this.state.showSideDrawer}
        sideDrawerClosedHandler={this.sideDrawerClosedHandler}
      >
        <Navbar>
          <NavbarLeft>
            <DrawerToggler clicked={this.sideDrawerTogglerHandler} />
          </NavbarLeft>
          <NavbarTitle title="Gear" leftOffset />
          <NavbarRight />
        </Navbar>
        <Page>
          <PageContent withNavbar>
            <div className={styles.Gear}>
              <p className={styles.Intro}>
                Recommended gear for Starting Strength training. Affiliate links support the gym.
              </p>
              {GEAR_ITEMS.map(item => (
                <a
                  key={item.id}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.Item}
                >
                  <div className={styles.ItemBody}>
                    <p className={styles.ItemName}>{item.name}</p>
                    <p className={styles.ItemVendor}>{item.vendor}</p>
                    <p className={styles.ItemDescription}>{item.description}</p>
                  </div>
                  <span className={styles.ItemCta}>{item.cta}</span>
                </a>
              ))}
            </div>
          </PageContent>
        </Page>
      </View>
    );
  }
}

export default withRouter(Gear);
